import orderBy from 'lodash/orderBy'
import { STOP_TYPE } from 'apps/fleet-planner/constants/loads'
import { IStop } from 'apps/fleet-planner/types/loads'

export interface ObjectWithStopType extends Partial<Pick<IStop, 'stopType' | 'stopSequence'>> {}

/**
 * Returns ordered array of Stop objects, filtered by `stopType`
 */
export function getFieldsByStopType<T extends ObjectWithStopType>(
  stops: T[] = [],
  stopType: STOP_TYPE = STOP_TYPE.pickup
): T[] {
  return orderBy(
    stops.filter(s => s.stopType === stopType),
    'stopSequence'
  )
}

/**
 * Returns object with `pickup` and `dropoff` arrays
 */
export function getFieldStops<T extends ObjectWithStopType>(
  stops: T[] = []
): Record<'pickup' | 'dropoff', T[]> {
  return {
    pickup: getFieldsByStopType(stops, STOP_TYPE.pickup),
    dropoff: getFieldsByStopType(stops, STOP_TYPE.dropoff),
  }
}
